import Icon from '../../components/Icon.vue'

Icon.register({"brands/stumbleupon-circle":{"width":496,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 185.5C246.2 185.5 238.2 193.5 238.2 203.3V310.2C238.2 351.1 204.3 384.1 163.3 384.1 121.9 384.1 88.4 350.6 88.4 309.2V262.7H145.7V308.5C145.7 318.5 153.7 326.3 163.5 326.3S181.3 318.4 181.3 308.5V200.1C181.3 160.1 215.5 128 256 128 296.7 128 330.7 160.3 330.7 200.6V224.3L296.6 234.4 273.7 223.7V203.1C273.8 193.5 265.8 185.5 256 185.5zM423.6 309.1C423.6 350.5 390.1 384 348.7 384 307.5 384 273.8 350.8 273.8 309.8V263L296.7 273.7 330.8 263.6V310.7C330.8 320.5 338.8 328.3 348.6 328.3S366.4 320.4 366.4 310.7V262.7H423.7C423.6 308.6 423.6 309.1 423.6 309.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/stumbleupon-circle.js
// module id = null
// module chunks = 